export enum ActionReasonVisibilityEnum {
  Admin = "Admin",
  Agent = "Agent"
}
